import { Box, TextField } from "@mui/material";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";

type FeatureFlagFormValues = {
  key: string;
  percentage: number;
  description: string;
};

export const FeatureFlagEdit = () => {
  const {
    saveButtonProps,
    register,
    formState: { errors },
  } = useForm<FeatureFlagFormValues>({});

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Box component="form" sx={{ display: "flex", flexDirection: "column" }} autoComplete="off">
        <TextField
          {...register("key")}
          margin="normal"
          fullWidth
          disabled
          InputLabelProps={{ shrink: true }}
          InputProps={{ readOnly: true }}
          type="text"
          label="Key"
          name="key"
          helperText="Key is immutable after creation"
        />

        <TextField
          {...register("percentage", {
            required: "Percentage is required",
            valueAsNumber: true,
            min: { value: 0, message: "Minimum is 0" },
            max: { value: 100, message: "Maximum is 100" },
          })}
          error={!!errors?.percentage}
          helperText={errors?.percentage?.message?.toString() ?? "0 = off, 100 = on for everyone"}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Rollout Percentage"
          name="percentage"
          inputProps={{ min: 0, max: 100, step: 1 }}
        />

        <TextField
          {...register("description", {
            maxLength: { value: 500, message: "Description is too long (max 500)" },
          })}
          error={!!errors?.description}
          helperText={errors?.description?.message?.toString()}
          margin="normal"
          fullWidth
          multiline
          minRows={2}
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Description"
          name="description"
        />
      </Box>
    </Edit>
  );
};
